import * as React from 'react';
import { useLanguage } from '../../locale';
import { useSearchFilters } from './useSearchFilters';
export var useLunchboxFilterSectionFacade = function () {
    var t = useLanguage()[0];
    var _a = React.useState(), lunchboxFilterOption = _a[0], setLunchboxFilterOption = _a[1];
    var _b = useSearchFilters(), setIsLunchboxToFilter = _b.setIsLunchboxToFilter, selectedIsLunchboxFilter = _b.selectedIsLunchboxFilter;
    var options = React.useMemo(function () {
        return [
            {
                type: 'default',
                label: "".concat(t('yes')),
                value: true,
            },
            {
                type: 'default',
                label: "".concat(t('filters.indifferent')),
                value: false,
            },
        ];
    }, [t]);
    React.useEffect(function () {
        if (selectedIsLunchboxFilter === null) {
            setLunchboxFilterOption(null);
        }
        else {
            var optionToSet = options.find(function (o) { return o.value === selectedIsLunchboxFilter; });
            setLunchboxFilterOption(optionToSet !== null && optionToSet !== void 0 ? optionToSet : null);
        }
    }, [options, selectedIsLunchboxFilter]);
    var reset = React.useCallback(function () {
        setLunchboxFilterOption(null);
        setIsLunchboxToFilter(null);
    }, [setIsLunchboxToFilter]);
    var applyFilter = React.useCallback(function () {
        var _a;
        setIsLunchboxToFilter((_a = lunchboxFilterOption === null || lunchboxFilterOption === void 0 ? void 0 : lunchboxFilterOption.value) !== null && _a !== void 0 ? _a : null);
    }, [lunchboxFilterOption, setIsLunchboxToFilter]);
    return {
        options: options,
        lunchboxFilterOption: lunchboxFilterOption,
        setLunchboxFilterOption: setLunchboxFilterOption,
        reset: reset,
        applyFilter: applyFilter,
    };
};
